import React, {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import PrimaryAppBar from './PrimaryAppBar';
import {selectUserGroup, selectUser} from '../../redux/slices/user';
import IconFlamingoLiteracyLogo from '../../components/icons/FlamingoLiteracyLogo';
import HandHeart from '../../components/icons/HandHeart';

import styles from '../css/LessonBuilder.module.css';

const PREFIX = 'LessonBuilder';

const classes = {
  square64: `${PREFIX}-square64`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.square64}`]: {
    height: 64,
    width: 64,
  },
});

export default function LessonBuilder() {
  const history = useHistory();
  const userGroup = useSelector(selectUserGroup);
  const user = useSelector(selectUser);

  const hasLogo = !!userGroup?.logoURL;

  // Temporarily re-direct user to Professional Info page if they are missing workplace
  useEffect(() => {
    if (user) {
      if (!user.professionalInformation?.workplace) {
        history.push('/builder/professional-info');
      }
    }
  }, [history, user]);

  return (
    <Root>
      <PrimaryAppBar />
      <div className={styles.container}>
        {hasLogo ? (
          <Avatar src={userGroup.logoURL} className={classes.square64} />
        ) : (
          <HandHeart className={classes.square64} />
        )}

        <Typography variant="h4" className="clr-primary fnt-bold m-t-15">
          {`Welcome ${userGroup.name}!`}
        </Typography>

        <Typography variant="h5" className="fnt-sans-alt m-t-10">
          Get started by clicking the menu button at the top left of your screen!
        </Typography>

        <IconFlamingoLiteracyLogo style={{width: 250, height: 91}} className="m-t-30" />
      </div>
    </Root>
  );
}
